import { ExplainerLayout } from '@/components/ExplainerLayout';
import { E_DORECZENIA_JDG } from '@/content/przewodniki';

const EDoreczeniaJdg2026 = () => <ExplainerLayout guide={E_DORECZENIA_JDG} />;

export default EDoreczeniaJdg2026;
